module.exports = __webpack_public_path__ + "static/img/brees-2005-top-image-thumb.c4c3cac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2005-top-image-thumb.jpg
// module id = 0LUt
// module chunks = 1